import React, { useState } from "react";
import { useHistory } from "react-router";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import { getBusinessPartnerModel } from "../BusinessPartner/Infrastructure/BusinessPartner.reducer";
import { Logout } from "../Auth/Infrastructure/Auth.presenter";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import iconHelp from "../assets/help.svg";
import iconHome from "../assets/home.svg";
import iconPaper from "../assets/paper.svg";
import iconlogout from "../assets/logout.svg";
import iconCar from "../assets/car.svg";
import iconUser from "../assets/user.svg";
import iconChat from "../assets/chat.svg";
import ListItemDrawer from "./ListItemDrawer";

const drawerWidth = 355;

const drawerStyles = {
  "& .MuiDrawer-paper": {
    paddingTop: "25px",
  },
};

const useStyles = makeStyles({
  root: {
    fontSize: 18,
  },
  headerList: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
});

const openedMixin = (theme) => ({
  justifyContent: "space-between",
  backgroundColor: "#004990",
  display: "flex",
  color: "#FFF",
  width: drawerWidth,
  borderTopRightRadius: 10,
  borderBottomRightRadius: 10,
  boxShadow: "0px 4px 4px #001B36",
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
});

const closedMixin = (theme) => ({
  backgroundColor: "#004990",
  display: "flex",
  justifyContent: "space-between",
  borderTopRightRadius: 10,
  borderBottomRightRadius: 10,
  boxShadow: "0px 4px 4px #001B36",
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(9)} + 1px)`,
  },
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function Navbar() {
  const classes = useStyles();
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const businessPartner = useSelector(getBusinessPartnerModel);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  if (!businessPartner) {
    return <></>;
  }

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const logout = async () => {
    try {
      await Logout();
      history.push("/");
    } catch (error) {
      alert("error signing out: ", error);
    }
  };

  return (
    <Drawer
      sx={drawerStyles}
      className={classes.root}
      onMouseEnter={handleDrawerOpen}
      onMouseLeave={handleDrawerClose}
      onKeyDown={handleDrawerOpen}
      onClick={handleDrawerOpen}
      variant="permanent"
      open={open}
    >
      <List className={classes.headerList}>
        <ListItemDrawer
          text={`${businessPartner.name} ${businessPartner.last_name}`}
          icon={businessPartner.url_photoProfile}
          avatar
          goTo="/perfil"
          onClick={() => history.push("/negocios")}
        />
        <ListItemDrawer
          text={"Negocios"}
          icon={iconHome}
          goTo="/negocios"
          onClick={() => history.push("/negocios")}
        />
        <ListItemDrawer text={"Personal"} icon={iconUser} menu>
          <>
            <ListItemDrawer
              text={"Repartidores"}
              goTo="/personal/repartidores"
              isSub
            />
            <ListItemDrawer text={"Asesores"} goTo="/personal/asesores" isSub />
          </>
        </ListItemDrawer>
        <ListItemDrawer
          isDisabled
          text={"Vehículos"}
          icon={iconCar}
          goTo="/vehiculos"
          onClick={() => history.push("/vehiculos")}
        />
        <ListItemDrawer text={"Reportes"} icon={iconPaper} menu>
          <>
            <ListItemDrawer text={"Comisiones"} goTo="/reportes/comisiones" isSub />
            <ListItemDrawer text={"Resumen"} goTo="/reportes/resumen" isSub isDisabled/>
            <ListItemDrawer text={"Edo. Cuenta"} goTo="/reportes/estadocuentas" isSub isDisabled/>
          </>
        </ListItemDrawer>
        <ListItemDrawer
          text={"Chat"}
          icon={iconChat}
          goTo="/chat"
          onClick={() => history.push("/chat")}
        />
      </List>

      <List>
        <ListItemDrawer
          text={"Servicio de ayuda"}
          icon={iconHelp}
          goTo="/ayuda"
          onClick={() => history.push("/ayuda")}
          isDisabled
        />
        <ListItemDrawer
          text={"Cerrar sesión"}
          icon={iconlogout}
          onClick={logout}
          isFunction
        />
      </List>
    </Drawer>
  );
}